var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"layout":'home',"title":_vm.siteTagline,"background":_vm.heroBg}}),_c('Banner',{attrs:{"layout":'text',"content":{
      text: _vm.bannerText,
      bgImg: _vm.bannerBg
    }}}),_c('Cards',{attrs:{"layout":'cta',"content":_vm.homeCta}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }